import styled from "@emotion/styled";
import { Button } from "react-aria-components";

export const PopupDialogCloseButton = styled(Button)`
  position: absolute;
  right: 0.5rem;
  top: 0.6rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;
